module.exports = __webpack_public_path__ + "static/media/MenuHamburger.60ac5169.svg";